var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageBranchList',{attrs:{"branches":_vm.branches && _vm.branches.entities ? _vm.branches.entities : []}})
}
var staticRenderFns = []

export { render, staticRenderFns }